import { useSyncExternalStore } from 'react';
import type { GalerieSession } from '../api/types.js';
import { DEFAULT_DESIGN, isDesignId } from './designs.js';
import {
  definirPolitiqueTheme,
  lirePolitiqueTheme,
  POLITIQUE_LIBRE,
  subscribeDesign,
  type PolitiqueTheme,
} from './designStore.js';

export { definirPolitiqueTheme, lirePolitiqueTheme, POLITIQUE_LIBRE, type PolitiqueTheme };

/**
 * Lot C — ce que la session dit du thème d'une galerie. Le thème se règle dans
 * la console ; `choixThemeClient` (coupé par défaut) rend à ses utilisateurs
 * le choix de leur design. Une session sans ces champs vaut ce que l'API donne
 * par défaut : Halo, choix coupé. Hors d'une galerie, rien n'est imposé.
 */
export function politiqueTheme(
  galerie: Pick<GalerieSession, 'theme' | 'choixThemeClient'> | null | undefined,
): PolitiqueTheme {
  if (!galerie) return POLITIQUE_LIBRE;
  return {
    theme: isDesignId(galerie.theme) ? galerie.theme : DEFAULT_DESIGN,
    libre: galerie.choixThemeClient === true,
  };
}

/** La politique publiée par la coquille pour la galerie affichée. */
export function usePolitiqueTheme(): PolitiqueTheme {
  return useSyncExternalStore(subscribeDesign, lirePolitiqueTheme, () => POLITIQUE_LIBRE);
}
